module.exports = __webpack_public_path__ + "img/test_paper.d62bac3e.svg";